import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type CustomerPortalSaveRetailPricesMutationVariables = Types.Exact<{
  tenantId: Types.Scalars['String']['input'];
  input: Types.CustomerPortalSaveRetailPricesInput;
}>;


export type CustomerPortalSaveRetailPricesMutation = { __typename?: 'Mutation', customerPortalSaveRetailPrices: { __typename?: 'CustomerPortalSaveRetailPricesPayload', save?: { __typename?: 'CustomerPortalRetailPriceSave', jobId: string, status: Types.BackgroundJobStatus, total: number, done: number, failed: number, createdAt: Types.TDateISO, updatedAt: Types.TDateISO, finishedAt?: Types.TDateISO | null } | null, invalidRows: Array<{ __typename?: 'CustomerPortalRetailPriceRowResult', rowIndex: number, itemId: string, action: Types.CustomerPortalRetailPriceAction, status: Types.CustomerPortalRetailPriceRowStatus, errors: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }>, customerRetailPrice?: { __typename?: 'CustomerRetailPrice', itemId: string, baselineToken: string, current?: { __typename?: 'CustomerRetailPriceRecord', customerItemId: string, price?: number | null, currency?: string | null, effectiveFrom?: Types.TDateISO | null, effectiveUntil?: Types.TDateISO | null, fromDate?: string | null, throughDate?: string | null } | null, last?: { __typename?: 'CustomerRetailPriceRecord', customerItemId: string, price?: number | null, currency?: string | null, effectiveFrom?: Types.TDateISO | null, effectiveUntil?: Types.TDateISO | null, fromDate?: string | null, throughDate?: string | null } | null, promo?: { __typename?: 'CustomerRetailPriceRecord', customerItemId: string, price?: number | null, currency?: string | null, effectiveFrom?: Types.TDateISO | null, effectiveUntil?: Types.TDateISO | null, fromDate?: string | null, throughDate?: string | null } | null, afterPromo?: { __typename?: 'CustomerRetailPriceRecord', customerItemId: string, price?: number | null, currency?: string | null, effectiveFrom?: Types.TDateISO | null, effectiveUntil?: Types.TDateISO | null, fromDate?: string | null, throughDate?: string | null } | null, scheduledStanding?: { __typename?: 'CustomerRetailPriceRecord', customerItemId: string, price?: number | null, currency?: string | null, effectiveFrom?: Types.TDateISO | null, effectiveUntil?: Types.TDateISO | null, fromDate?: string | null, throughDate?: string | null } | null } | null }>, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };


export const CustomerPortalSaveRetailPricesDocument = new TypedDocumentString(`
    mutation CustomerPortalSaveRetailPrices($tenantId: String!, $input: CustomerPortalSaveRetailPricesInput!) {
  customerPortalSaveRetailPrices(tenantId: $tenantId, input: $input) {
    save {
      ...CustomerPortalRetailPriceSaveFields
    }
    invalidRows {
      ...CustomerPortalRetailPriceRowResultFields
    }
    errors {
      code
      message
    }
  }
}
    fragment CustomerPortalRetailPriceSaveFields on CustomerPortalRetailPriceSave {
  jobId
  status
  total
  done
  failed
  createdAt
  updatedAt
  finishedAt
}
fragment CustomerPortalRetailPriceRowResultFields on CustomerPortalRetailPriceRowResult {
  rowIndex
  itemId
  action
  status
  errors {
    code
    message
  }
  customerRetailPrice {
    ...CustomerRetailPriceFields
  }
}
fragment CustomerRetailPriceFields on CustomerRetailPrice {
  itemId
  current {
    ...CustomerRetailPriceRecordFields
  }
  last {
    ...CustomerRetailPriceRecordFields
  }
  promo {
    ...CustomerRetailPriceRecordFields
  }
  afterPromo {
    ...CustomerRetailPriceRecordFields
  }
  scheduledStanding {
    ...CustomerRetailPriceRecordFields
  }
  baselineToken
}
fragment CustomerRetailPriceRecordFields on CustomerRetailPriceRecord {
  customerItemId
  price
  currency
  effectiveFrom
  effectiveUntil
  fromDate
  throughDate
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    CustomerPortalSaveRetailPrices: build.mutation<CustomerPortalSaveRetailPricesMutation, CustomerPortalSaveRetailPricesMutationVariables>({
      query: (variables) => ({ document: CustomerPortalSaveRetailPricesDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useCustomerPortalSaveRetailPricesMutation } = injectedRtkApi;
